<mat-card fxFlex.gt-sm="60" fxFlexOffset.gt-sm="20" fxFlex="100">
  <mat-card-title>Duty Off</mat-card-title>
  <mat-card-subtitle>{{ pilotName }}</mat-card-subtitle>
  <mat-divider></mat-divider>
  <mat-card-content *ngIf="params$ | async; let params; else: loading">
    <fl-duty-off-form [params]="params"></fl-duty-off-form>
  </mat-card-content>
  <mat-divider> </mat-divider>
  <mat-card-actions *ngIf="formCmp">
    <button mat-raised-button color="primary" (click)="dutyOff()" [disabled]="formCmp.form.invalid">
      Duty Off
    </button>
  </mat-card-actions>
  <ng-template #loading>
    <fl-loading-container [loading]="true"> </fl-loading-container>
  </ng-template>
</mat-card>
